import { memo } from 'react'
import { Cell } from 'react-table'
import { Box, Flex, IconButton } from 'theme-ui'
import moment from 'moment'
import { Text, Chip, Tooltip } from 'components'
import { InfoIcon } from 'components/Icon'
import {
  STUDENT_INPERSON,
  STUDENT_DC,
  TMATT_STATUS_TYPES,
} from '../../constants'
import { formatProgress } from 'utils/digitalCourseStudents'
import { isV2OrHigher, calculateV2Progress } from 'utils/dc'
import { ModuleProgress } from 'types'

function propsAreEqual(prevProps: Cell, nextProps: Cell) {
  return nextProps.value === prevProps.value
}

const StudentType: any = {
  [STUDENT_INPERSON]: 'IP',
  [STUDENT_DC]: 'DC',
}

export const TableCell = memo(function ({
  column,
  getCellProps,
  value,
  render,
  activeList,
  row,
}: Cell & { activeList: string }) {
  const { Header } = column

  if (Header === 'Status' || Header === 'Training Status') {
    return (
      <Box as="td" {...getCellProps()} sx={{ width: 130 }}>
        <Flex sx={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          <Chip
            variant={
              (activeList === 'tmatt' || activeList === 'refresher') &&
              value === 'completed'
                ? 'completedTmatt'
                : value
            }
          />{' '}
          <Tooltip
            variant={value}
            tooltipSx={{ right: 0 }}
            // @ts-ignore
            userType={row?.original?.userType}
            activeList={activeList}
          >
            <IconButton variant={`icon.${value}`} sx={{ outline: 'none' }}>
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Flex>
      </Box>
    )
  }

  if (Header === 'Format') {
    return (
      <Box as="td" {...getCellProps()} sx={{ width: 41 }}>
        <Text sx={{ userSelect: 'none' }}>{StudentType[value]}</Text>
      </Box>
    )
  }

  if (Header === 'Training Status') {
    return (
      <Box as="td" {...getCellProps()} sx={{ minWidth: 60 }}>
        <Text sx={{ userSelect: 'none' }}>{TMATT_STATUS_TYPES[value]}</Text>
      </Box>
    )
  }
  if (
    Header === 'Instruction Date' ||
    Header === 'Enrolled Date' ||
    Header === 'Due Date'
  ) {
    return (
      <Box as="td" {...getCellProps()} sx={{ width: 140 }}>
        <Text sx={{ userSelect: 'none' }}>
          {moment(value).format('MMM DD, YYYY')}
        </Text>
      </Box>
    )
  }

  if (Header === 'Email') {
    return (
      <td {...getCellProps()}>
        <Text
          sx={{ userSelect: 'none', wordWrap: 'break-word', maxWidth: 300 }}
        >
          {render('Cell')}
        </Text>
      </td>
    )
  }

  if (Header === 'Position') {
    const original = row?.original as any
    const dcVersion = original?.dcVersion as string | undefined
    const moduleProgress = original?.moduleProgress as
      | ModuleProgress[]
      | undefined

    // Use v2 format if version is 2.0.0+
    if (
      isV2OrHigher(dcVersion) &&
      moduleProgress &&
      moduleProgress.length > 0
    ) {
      const v2Progress = calculateV2Progress(moduleProgress)

      if (!v2Progress) return null

      return (
        <Box as="td" {...getCellProps()} sx={{ width: 130 }}>
          <Flex sx={{ alignItems: 'center', justifyContent: 'flex-start' }}>
            <Text
              sx={{
                userSelect: 'none',
              }}
            >
              {v2Progress}%
            </Text>
            <Tooltip
              message={moduleProgress
                .map(({ module, percentage }) => `M${module}-${percentage}%`)
                .join(', ')}
              tooltipSx={{ right: 0 }}
            >
              <IconButton sx={{ outline: 'none', cursor: 'pointer' }}>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Flex>
        </Box>
      )
    }

    // Fallback to legacy format
    return (
      <td {...getCellProps()}>
        <Text
          sx={{ userSelect: 'none', wordWrap: 'break-word', maxWidth: 140 }}
        >
          {formatProgress(value)}
        </Text>
      </td>
    )
  }
  return (
    <td {...getCellProps()}>
      <Text sx={{ userSelect: 'none' }}>{render('Cell')}</Text>
    </td>
  )
},
propsAreEqual)
